// Global resize observer is better for perf
// https://github.com/WICG/resize-observer/issues/59
import { isServer } from './isSSR';
// We have a map by Element which contains a Set of callbacks, gives
// use single listener per element that dispatches multiple callbacks
const callbacksMap = new WeakMap();
/**
 * Get the set of callbacks for an element
 */ const getCallbacks = (element)=>{
    let callbacks = callbacksMap.get(element);
    if (!callbacks) {
        callbacks = new Set();
        callbacksMap.set(element, callbacks);
    }
    return callbacks;
};
/**
 * Init a global observer
 */ let observer;
if (!isServer()) {
    observer = new ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const callbackSet = getCallbacks(entry.target);
            callbackSet.forEach((cb)=>{
                cb(entries.filter((e)=>e.target === entry.target));
            });
        });
    });
}
/**
 * Observe an elements resize
 */ export function observeResize(element, callback) {
    getCallbacks(element).add(callback);
    observer === null || observer === void 0 ? void 0 : observer.observe(element);
}
/**
 * Unobserve an elements resize
 */ export function unobserveResize(element, callback) {
    const callbacks = getCallbacks(element);
    callbacks.delete(callback);
    // No more callbacks associated, turn off the observer
    if (!callbacks.size) {
        observer === null || observer === void 0 ? void 0 : observer.unobserve(element);
    }
}

//# sourceMappingURL=globalResizeObserver.js.map